module.exports = __webpack_public_path__ + "static/media/numero 3 copia.841cf802.png";